export default __webpack_public_path__ + "static/media/Bloodseraph's Armguards.d0ca7db8.jpg";